import React, { memo } from 'react'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { push } from 'connected-react-router'
import { logout } from 'app-redux/user/actions'
import { checkPermission } from 'app-redux/user/selectors'
import { formatDate } from 'utils/formatting'
import { Upgrade } from 'components/UI/Button'
import { Avatar, Dropdown } from 'antd'
import { compareWithJSON } from 'utils/helper'
import styles from './style.module.scss'

const ICON_BASE = 'resources/images/icons/menu-v2'

class ProfileMenu extends React.Component {
  state = {
    open: false,
  }

  handleOpenChange = (open) => {
    this.setState({ open })
  }

  closeMenu = () => {
    this.setState({ open: false })
  }

  logout = async (e) => {
    e.preventDefault()
    this.closeMenu()
    await this.props.onLogout()
    this.props.push('/user/login')
  }

  goToUpgradeHandler = () => {
    this.closeMenu()
    if (this.props.billing.can_be_renewed) {
      this.props.push('/settings/billing/upgrade?isRenew=1')
      return
    }
    this.props.push('/settings/billing/upgrade')
  }

  renderCard = () => {
    const { user, billing, intl, hasAccessToBilling } = this.props
    const showUpgrade = (billing.can_be_upgraded || billing.can_be_renewed) && hasAccessToBilling

    return (
      <div className={styles.card}>
        <div className={styles.header}>
          <Avatar
            className={styles.avatarLg}
            shape="square"
            size={44}
            icon={<UserOutlined />}
            src={user.profile_image}
          />
          <div className={styles.headText}>
            <div className={styles.hello}>
              <FormattedMessage id="topBar.profileMenu.hello" />, {user.name || 'Anonymous'}
            </div>
            {user.email && <div className={styles.headEmail}>{user.email}</div>}
          </div>
        </div>

        <div className={styles.contact}>
          <div className={styles.contactRow}>
            <img className={styles.contactIcon} src={`${ICON_BASE}/pm-phone.svg`} alt="" />
            <span className={styles.contactText}>{user.phone_number || '-'}</span>
          </div>
        </div>

        <div className={styles.planBox}>
          <div className={styles.planRow}>
            <span className={styles.planLabel}>
              <FormattedMessage id="topBar.billing.plan" />
            </span>
            <span className={styles.planValue}>{billing.plan}</span>
          </div>
          <div className={styles.planRow}>
            <span className={styles.planLabel}>
              <FormattedMessage id="topBar.billing.active_until" />
            </span>
            <span className={styles.planValue}>
              {billing.expiry_date ? (
                formatDate(
                  new Date(billing.expiry_date).setDate(
                    new Date(billing.expiry_date).getDate() - 1,
                  ),
                )
              ) : (
                <FormattedMessage id="topBar.billing.forever" />
              )}
            </span>
          </div>
          {showUpgrade && (
            <Upgrade
              className={styles.upgradeBtn}
              onClick={this.goToUpgradeHandler}
              title={intl.formatMessage({
                id: billing.can_be_renewed ? 'button.renew' : 'button.upgrade',
              })}
            />
          )}
        </div>

        <div className={styles.actions}>
          <Link to="/referral" className={styles.actionRow} onClick={this.closeMenu}>
            <img className={styles.actionIcon} src={`${ICON_BASE}/pm-referral.svg`} alt="" />
            <span>
              <FormattedMessage id="referral.referral" />
            </span>
          </Link>
          <Link to="/settings/profile" className={styles.actionRow} onClick={this.closeMenu}>
            <img className={styles.actionIcon} src={`${ICON_BASE}/pm-profile.svg`} alt="" />
            <span>
              <FormattedMessage id="profile.profile" />
            </span>
          </Link>
          <a href="#" onClick={this.logout} className={`${styles.actionRow} ${styles.logoutRow}`}>
            <img className={styles.actionIcon} src={`${ICON_BASE}/action-logout.svg`} alt="" />
            <span>
              <FormattedMessage id="topBar.profileMenu.logout" />
            </span>
          </a>
        </div>
      </div>
    )
  }

  render() {
    const { user } = this.props

    return (
      <Dropdown
        popupRender={this.renderCard}
        trigger={['click']}
        placement="bottomRight"
        overlayClassName={styles.overlay}
        open={this.state.open}
        onOpenChange={this.handleOpenChange}
      >
        <div className={styles.dropdown}>
          <Avatar
            className={styles.avatar}
            shape="square"
            size="large"
            icon={<UserOutlined />}
            src={user.profile_image}
          />
        </div>
      </Dropdown>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state._inits.user,
    billing: state.billing,
    hasAccessToBilling: checkPermission(state, 'billing'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(logout()),
    push: (path) => dispatch(push(path)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(injectIntl(ProfileMenu), compareWithJSON))
